import React from 'react';
import { useTheme } from '../../../contexts/ThemeContext';

// Production shows the team/participant name in full, and — only for a
// specific MLP discipline row — a muted sub-line of that discipline's actual
// players, FIRST NAMES ONLY (ScheduleTab.jsx: `p.name.split(' ')[0]`), under
// it. The two are additive, never a replacement of one by the other.
const playersLine = (players) => players?.map((p) => p.name.split(' ')[0]).join(' / ');

// One participant slot (name + optional per-discipline players sub-line).
// Shared by MatchRow's mobile card cell and desktop table cell — the only
// piece of a match row that's identical in both layouts.
const NameBlock = ({ entry, placeholder, players, align = 'text-left' }) => {
  const { theme } = useTheme();
  const isEmpty = !entry && !placeholder;
  const isPlaceholderText = !entry && placeholder;
  return (
    <div className="min-w-0">
      <span
        className={`block truncate text-sm font-semibold ${align} ${
          isEmpty ? theme.textMuted : entry?.isPlaceholder || isPlaceholderText ? `italic ${theme.textMuted}` : theme.text
        }`}
      >
        {entry?.name || placeholder || 'BYE'}
      </span>
      {players?.length > 0 && <div className={`truncate text-xs ${theme.textMuted} ${align}`}>{playersLine(players)}</div>}
    </div>
  );
};

export default NameBlock;
